/**
 * @file Client Component から使う router の唯一の入口。
 * `next/navigation` の `useRouter` を直接使うと `router.push()` 起点の遷移で
 * 進捗バーが出ないため、進捗バー付きの router に一本化する。
 * `next/navigation` からの `useRouter` import は biome の noRestrictedImports で禁止している。
 */

export { useRouter } from "@bprogress/next/app";
